import { render, staticRenderFns } from "./feedbackAdd.vue?vue&type=template&id=44e038d4&scoped=true&"
import script from "./feedbackAdd.vue?vue&type=script&lang=js&"
export * from "./feedbackAdd.vue?vue&type=script&lang=js&"
import style0 from "./feedbackAdd.vue?vue&type=style&index=0&id=44e038d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e038d4",
  null
  
)

export default component.exports